export const download = (fileName, exportFunction) => {
  exportFunction
    .then((res) => {
      try {
        const blob = new Blob([res.data], { type: 'application/excel' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName.includes('.xlsx')
          ? fileName
          : `${fileName}.xlsx`;
        link.click();
      } catch (e) {
        console.log(e);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
